/* global grecaptcha, ___grecaptcha_cfg */
import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    constructor() {
        super();

        this.timer = null;
        this.element = null;
        this.recaptcha_id = null;
        this.recaptcha_url = 'https://www.google.com/recaptcha/api.js?&onload=recaptchaLoaded&render=explicit';

        this.isRecaptchaLoaded = () => typeof window !== 'undefined' && typeof window.grecaptcha !== 'undefined';
    }

    componentDidMount() {
        this.initializeRecaptcha();
    }

    componentWillUnmount() {
        this.clearTimer();

        if (this.isRecaptchaLoaded() && this.element && this.recaptcha_id !== null) {
            this.removeRecaptcha();
        }

        if (window.___grecaptcha_cfg) {
            delete ___grecaptcha_cfg.clients[this.recaptcha_id];
            ___grecaptcha_cfg.count--;
        }
    }

    render() {
        return (
            <invisible-recaptcha ref={this.captureRef} class='is-hidden' />
        );
    }

    initializeRecaptcha = () => {
        if (this.isRecaptchaLoaded()) {
            this.clearTimer();
            this.renderRecaptcha();
        } else if (!this.isRecaptchaJSLibInjected()) {
            let script = document.createElement('script');

            window.recaptchaLoaded = this.initializeRecaptcha.bind(this);

            script.src = this.recaptcha_url;
            script.async = 1;
            script.defer = 1;

            script.onerror = () => {
                console.log('Error loading google recaptcha!'); //eslint-disable-line no-console
            };

            document.body.appendChild(script);
        } else {
            this.startTimer();
        }
    }

    renderRecaptcha = () => {
        this.recaptcha_id = grecaptcha.render(this.element, {
            'sitekey': '6LctH00UAAAAAPXEJwIiS8GQ8x3XUmyAZg4QgY-P',
            'callback': this.handleChange,
            'theme': 'light',
            'type': 'image',
            'tabindex': 0,
            'expired-callback': this.handleExpired,
            'size': 'invisible',
            'stoken': null,
            'badge': 'inline',
        });
    }

    removeRecaptcha = () => {
        grecaptcha.reset(this.recaptcha_id);
    }

    clearTimer = () => {
        if (this.waitingTimer !== null) {
            clearTimeout(this.timer);
        }
    }

    startTimer = () => {
        this.timer = setTimeout(this.initializeRecaptcha, 200);
    }

    isRecaptchaJSLibInjected = () => {
        if (typeof window === 'undefined') {
            return false;
        }

        if (!document.scripts || document.scripts.length === 0) {
            return false;
        }

        let scripts = Object.assign([], document.scripts);

        return (scripts.filter((script) => {
            return script.src.match(/((http|https):)?\/\/(www\.)?google\.com\/recaptcha\/(.*)/i) !== null;
        })).length > 0;
    }

    handleChange = (response) => {
        if (this.props.onChange && typeof this.props.onChange === 'function') {
            this.props.onChange(response);
        }
    }

    handleExpired = () => {
        if (this.props.onExpired && typeof this.props.onExpired === 'function') {
            this.props.onExpired();
        }
    }

    execute = () => {
        if (this.isRecaptchaLoaded() && this.element && this.recaptcha_id !== null) {
            grecaptcha.execute(this.recaptcha_id);
            return true;
        }

        return false;
    }

    reset = () => {
        if (this.isRecaptchaLoaded() && this.element && this.recaptcha_id !== null) {
            grecaptcha.reset(this.recaptcha_id);
            return true;
        }

        return false;
    }

    captureRef = (element) => {
        this.element = element;
    }
}

export default connect()(Component);



// WEBPACK FOOTER //
// ./app/components/invisible-recaptcha.js